'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function PricingCTA(p) {
    var className = 'seo-cloud-integrations__main__free_accounts__' + p.position;

    var text = p.text ? p.text : 'Free accounts include three documents a month. Upgrade to a business plan for unlimited documents.';
    var linkUrl = p.linkUrl ? p.linkUrl : 'info/pricing';
    var linkText = p.linkText ? p.linkText : 'See Our Plans';
    var link = _react2['default'].createElement(
        'a',
        { href: linkUrl, style: { fontWeight: 500 }, onClick: p.onClick },
        linkText
    );

    return _react2['default'].createElement(
        'div',
        { className: className, style: p.style },
        text,
        '\xA0',
        link,
        '.'
    );
}

module.exports = PricingCTA;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/pricing-cta-section.jsx
 ** module id = 1250
 ** module chunks = 0
 **/